import { Component, inject } from '@angular/core';
import { CONTRIBUTE_EMAIL, CONTRIBUTE_SUBJECT, CONTRIBUTE_BODY } from '../app.constants';
import { UnicodeBoldPipe, UnicodeItalicPipe } from '../shared/pipes/unicode-text.pipe';
import { PrimaryBtnDirective } from '../shared/primary-button';

@Component({
  selector: 'contribute-asset-button',
  template: ` <a appPrimaryBtn [href]="contributeMailToLink">Contribute an Asset</a> `,
  styles: ``,
  imports: [PrimaryBtnDirective],
  providers: [UnicodeBoldPipe, UnicodeItalicPipe],
})
export class ContributeAssetButton {
  private boldPipe = inject(UnicodeBoldPipe);
  private italicPipe = inject(UnicodeItalicPipe);

  buildContributeMailToLink = () => {
    const body = [
      CONTRIBUTE_BODY.intro,
      '',
      ...CONTRIBUTE_BODY.boldFields.map(
        ([label, value]) => `${this.boldPipe.transform(label)}: ${value}`,
      ),
      '',
      this.italicPipe.transform(CONTRIBUTE_BODY.italicNote),
    ].join('\n');

    return `mailto:${CONTRIBUTE_EMAIL}?subject=${encodeURIComponent(CONTRIBUTE_SUBJECT)}&body=${encodeURIComponent(body)}`;
  };
  contributeMailToLink = this.buildContributeMailToLink();
}
